import type { DocumentActionsItem } from "@/components/DocumentActionsMenuContent";

/** Minimal shape shared by Library unified rows and action menus. */
export type LibraryBrowsableItem = {
  id: string;
  title: string;
  itemType: "note" | "reference";
  folderId?: string | null;
  includeInRag?: boolean;
  isLocked?: boolean;
  url?: string | null;
  type?: string | null;
  tags?: string[] | null;
};

export function unifiedItemToDocumentActions(item: LibraryBrowsableItem): DocumentActionsItem {
  return {
    id: item.id,
    title: item.title,
    itemType: item.itemType,
    folderId: item.folderId ?? null,
    includeInRag: item.includeInRag,
    isLocked: item.isLocked,
    url: item.url ?? null,
    type: item.type ?? null,
    tags: item.tags ?? null,
  };
}
